export default __webpack_public_path__ + "static/screens-top-34ead713f8bbbab6c8d82c938550f858.jpg";